import { useAuth } from '../../context/AuthContext'
import { useAttendance } from '../../context/AttendanceContext'
import { Button } from '@jira-clone/ui'
import { LogIn } from 'lucide-react'

export default function CheckInScreen() {
  const { user } = useAuth()
  const { checkIn, workingHours } = useAttendance()

  // Get current time greeting
  const hour = new Date().getHours()
  let greeting = 'Good morning'
  if (hour >= 12 && hour < 17) greeting = 'Good afternoon'
  else if (hour >= 17) greeting = 'Good evening'

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-muted/20 backdrop-blur-sm z-[9999] fixed inset-0">
      <div className="bg-card p-10 rounded-2xl shadow-xl border border-border flex flex-col items-center max-w-md w-full text-center">
        <div className="h-16 w-16 bg-primary/10 rounded-full flex items-center justify-center mb-6">
          <LogIn className="h-8 w-8 text-primary" />
        </div>
        
        <h1 className="text-2xl font-bold text-foreground mb-2">
          {greeting}, {user?.name || 'User'}
        </h1>
        
        <p className="text-sm text-muted-foreground mb-8">
          Check in to start using Zynx today.
          {workingHours && (
            <span className="block mt-1 opacity-70">
              Office Hours: {workingHours.start} - {workingHours.end}
            </span>
          )}
        </p>

        <Button 
          size="lg" 
          className="w-full text-md font-semibold h-12"
          onClick={checkIn}
        >
          Check In
        </Button>
      </div>
    </div>
  )
}
